import React, { useState, useContext } from 'react';
import { withStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import Dialog from 'libraries/Dialog';
import { observer } from 'mobx-react-lite';
import CircularProgress from '@mui/material/CircularProgress';
import RemoveIcon from 'img/remove.svg';
import { deleteAllScreeningQuestions } from 'requests/QuestionsRequests';
import AssessmentEvents from 'events/AssessmentEvents';
import { appCtx } from 'components/appStore';
import { assessmentEditCtx } from '../../../../store';
import { assessmentSettingsCtx } from '../../../../../../store';

const styles = () => ({
    actionButton: {
        fontWeight: 700,
        paddingRight: 20,
        paddingLeft: 20
    },
    deleteButton: {
        fontWeight: 700,
        minWidth: 174
    },
    modalContentItem: {
        margin: '10px 0',
        fontWeight: 'bold',
        fontSize: 20,
        textAlign: 'center'
    },
    icon: {
        width: 60
    }
});

const DeleteScreeningDialog = observer(({ classes, open, onClose, slug, audition, screeningQuestionsNumber }) => {
    const [loading, setLoading] = useState(false);
    const { screeningQuestionsList } = useContext(assessmentEditCtx);
    const { loadEditScript } = useContext(assessmentSettingsCtx);
    const { flashMessage } = useContext(appCtx);

    const onDelete = () => {
        setLoading(true);
        deleteAllScreeningQuestions(slug)
            .then(() => {
                AssessmentEvents.SCREENER_DELETED({
                    ttUUID: audition.uuid,
                    ttName: audition.name,
                    screeningQuestionsNumber
                });
                onClose();
                loadEditScript();
                flashMessage('Screener deleted', 'done');
                screeningQuestionsList.loadList(slug);
                setLoading(false);
            });
    };

    return (
        <Dialog
            maxWidth="sm"
            actionComponent={(
                <>
                    <Button
                        className={classes.actionButton}
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        disabled={loading}
                        className={classes.deleteButton}
                        onClick={onDelete}
                    >
                        {
                            loading ? (
                                <CircularProgress
                                    size={24}
                                    thickness={3}
                                />
                            ) : <span>Delete Screener</span>
                        }
                    </Button>
                </>
            )}
            open={open}
            onClose={onClose}
            handleClose={onClose}
        >
            <div className="u-dsp--f u-fdir--column u-ai--center">
                <img className={classes.icon} src={RemoveIcon} alt="x" />
                <div className={classes.modalContentItem}>Are you sure you want to delete <br />the screener?</div>
                You will not be able to undo this action.
            </div>
        </Dialog>
    );
});

export default withStyles(styles)(DeleteScreeningDialog);
